// Vue
import {VNodeData} from 'vue'
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Mixins
import {EventBus} from '../../../../mixins/event_bus/EventBus'

// template
import template from './template.vue'

// Components
import {Icon} from '../../icon/Icon'

import LazysizesDirective from '../../../../utils/LazysizesDirective';

@Component({
    name: 'SliderItemImg',
    components: {
        Icon,
    },
    mixins: [
        template
    ],
    directives: {
        lazysizes: LazysizesDirective
    }
})
export class SliderItemImg extends mixins(EventBus) {

    public mouseTouchPosition: number | null = null

    @Prop({default: true})
    public shouldNotify!: boolean

    @Prop({default: false})
    public active!: boolean

    @Prop()
    public duration!: number

    @Prop()
    public text!: string

    @Prop()
    public thumbnail!: string

    @Prop()
    public imgSrc!: string

    @Prop()
    public bgSrc!: string

    @Prop()
    public alt!: string

    @Prop({default: false})
    public lightbox!: boolean

    @Prop()
    public openIcon!: string

    @Prop()
    public lazyloadingImg?: string

    public created() {

        if (this.shouldNotify) {

            this.dispatch('Slider', 'registerSlide', [{
                active: this.active,
                duration: this.duration,
                text: this.text,
                component: 'SliderItemImg',
                props: {
                    imgSrc: this.imgSrc,
                    bgSrc: this.bgSrc,
                    lazyloadingImg: this.lazyloadingImg,
                    alt: this.alt,
                    text: this.text,
                    lightbox: this.lightbox,
                    openIcon: this.openIcon,
                },
            }])
        }
    }

    public mounted () {

    }

    public destroyed() {

    }

    public handleMouseDown(e: MouseEvent) {

        if (!this.lightbox) return

        this.mouseTouchPosition = e.clientX
    }

    public handleMouseUp(e: MouseEvent) {

        if (!this.lightbox) return

        const positionDifference = this.mouseTouchPosition! - e.clientX

        if (positionDifference < 5 && positionDifference > -5) {            

            this.$emit('lightbox', {
                imgSrc: this.imgSrc,
                bgSrc: this.bgSrc,
                lazyloadingImg: this.lazyloadingImg,
                title: this.text
            })
        }
    }
}